import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


const router =  new Router({
    mode:'history',
    routes: [
        {
            path: '/',
            component: (resolve) => { require(['../components/login.vue'], resolve) },
            name: 'login',
            meta: {requireAuth: false},
        },
        {
            path: '/downloadOrders',
            component: (resolve) => { require(['../components/downloadOrders.vue'], resolve) },
            name: 'downloadOrders',
            meta: {requireAuth: false},
        },
        {
            path: '/inhosPrint',
            component: (resolve) => { require(['../components/inhosPrint.vue'], resolve) },
            name: 'inhosPrint',
            meta: {requireAuth: false},
        },
        {
            path: '/home',
            component: (resolve) => { require(['../components/home.vue'], resolve) },
            name: 'home',
            meta: {requireAuth: false},
        },

        {
            path: '/index',
            name: 'index',
            component: (resolve) => { require(['../components/index.vue'], resolve) },
            meta: {requireAuth: true},
            children:[
                {
                    path: '/sheet7',
                    component: (resolve) => { require(['../components/sheet7.vue'], resolve) },
                    name: 'sheet7',
                    meta: {requireAuth: true}
                },
                {
                    path: '/sheet1',
                    component: (resolve) => { require(['../components/sheet1.vue'], resolve) },
                    name: 'sheet1',
                    meta: {requireAuth: true}
                },
                {
                    path: '/sheet2',
                    component: (resolve) => { require(['../components/sheet2.vue'], resolve) },
                    name: 'sheet2',
                    meta: {requireAuth: true}
                },
                {
                    path: '/sheet3',
                    component: (resolve) => { require(['../components/sheet3.vue'], resolve) },
                    name: 'sheet3',
                    meta: {requireAuth: true}
                },
                {
                    path: '/sheet4',
                    component: (resolve) => { require(['../components/sheet4.vue'], resolve) },
                    name: 'sheet4',
                    meta: {requireAuth: true}
                },
                {
                    path: '/sheet5',
                    component: (resolve) => { require(['../components/sheet5.vue'], resolve) },
                    name: 'sheet5',
                    meta: {requireAuth: true}
                },
                {
                    path: '/sheet6',
                    component: (resolve) => { require(['../components/sheet6.vue'], resolve) },
                    name: 'sheet6',
                    meta: {requireAuth: true}
                },
                {
                    path: '/report',
                    component: (resolve) => { require(['../components/report.vue'], resolve) },
                    name: 'report',
                    meta: {requireAuth: true}
                },
                {
                    path: '/permissions',
                    component: (resolve) => { require(['../components/permissions.vue'], resolve) },
                    name: 'permissions',
                    meta: {requireAuth: true}
                },
                {
                    path: '/newTan',
                    component: (resolve) => { require(['../components/newTan.vue'], resolve) },
                    name: 'newTan',
                    meta: {requireAuth: false},
                },
                {
                    path: '/sheet8',
                    component: (resolve) => { require(['../components/sheet8.vue'], resolve) },
                    name: 'sheet8',
                    meta: {requireAuth: true}
                },
                {
                    path: '/news',
                    component: (resolve) => { require(['../components/news.vue'], resolve) },
                    name: 'news',
                    meta: {requireAuth: true}
                },
				{
				    path: '/inhos1',
				    component: (resolve) => { require(['../components/inhos1.vue'], resolve) },
				    name: 'inhos1',
				    meta: {requireAuth: true}
				},
				{
				    path: '/inhos2',
				    component: (resolve) => { require(['../components/inhos2.vue'], resolve) },
				    name: 'inhos2',
				    meta: {requireAuth: true}
                },
                {
				    path: '/inhosGen',
				    component: (resolve) => { require(['../components/inhosGen.vue'], resolve) },
				    name: 'inhosGen',
				    meta: {requireAuth: true}
                },
                {
				    path: '/inReport',
				    component: (resolve) => { require(['../components/inReport.vue'], resolve) },
				    name: 'inReport',
				    meta: {requireAuth: true}
                }
                
            ]
        }
    ]
})

router.beforeEach((to,from,next) => {
    if(to.meta.requireAuth){ // 判断跳转的路由是否需要登录
      if(sessionStorage.getItem("token")){ // token是否存在
        next() //已登录
      }else{
        next({path:'/'})
      }
    }else{
       next()
    }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js